export const ACTIVE   = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const NONE     = 'NONE';
export const WAITING  = 'WAITING';

export const accessories = {
  // DNBH64403 Name Badges Bag & Lace
  '727826440300030': 'DNBH64403 Bag & Lace',
  '727826440500030': 'DNBH64403 Bag & Lace',

  // DA270ENV25 Envelope A2
  '727826435100030': 'DA27OENV25 Envelope A2',
  '727826435200030': 'DA27OENV25 Envelope A2',
  '727826435400030': 'DA27OENV25 Envelope A2',
  '727826435500030': 'DA27OENV25 Envelope A2',
  '727826435700030': 'DA27OENV25 Envelope A2',
  '727826435800030': 'DA27OENV25 Envelope A2',
  '727826436000030': 'DA27OENV25 Envelope A2',
  '727826436100030': 'DA27OENV25 Envelope A2',
  '727826447700030': 'DA27OENV25 Envelope A2',
  '727826447800030': 'DA27OENV25 Envelope A2',
  '727826448000030': 'DA27OENV25 Envelope A2',
  '727826448100030': 'DA27OENV25 Envelope A2',
  '727826448300030': 'DA27OENV25 Envelope A2',
  '727826448400030': 'DA27OENV25 Envelope A2',
  '727826448600030': 'DA27OENV25 Envelope A2',
  '727826448700030': 'DA27OENV25 Envelope A2',
  // 2019 Card Line extensions
  '727826987800030': 'DA27OENV25 Envelope A2',
  '727826987900030': 'DA27OENV25 Envelope A2',
  '727826988000030': 'DA27OENV25 Envelope A2',
  '727826988100030': 'DA27OENV25 Envelope A2',
  '727826988600030': 'DA27OENV25 Envelope A2',
  '727826988700030': 'DA27OENV25 Envelope A2',
  '727826988800030': 'DA27OENV25 Envelope A2',
  '727826988900030': 'DA27OENV25 Envelope A2',
  '727826990200030': 'DA27OENV25 Envelope A2',
  '727826990300030': 'DA27OENV25 Envelope A2',
  '727826990400030': 'DA27OENV25 Envelope A2',
  '727826990500030': 'DA27OENV25 Envelope A2',
  '727826991000030': 'DA27OENV25 Envelope A2',
  '727826991100030': 'DA27OENV25 Envelope A2',
  '727826991200030': 'DA27OENV25 Envelope A2',
  '727826991300030': 'DA27OENV25 Envelope A2',
  '727826995000030': 'DA27OENV25 Envelope A2',
  '727826995100030': 'DA27OENV25 Envelope A2',
  '727826995200030': 'DA27OENV25 Envelope A2',
  '727826995300030': 'DA27OENV25 Envelope A2',
  '727826995800030': 'DA27OENV25 Envelope A2',
  '727826995900030': 'DA27OENV25 Envelope A2',
  '727826996000030': 'DA27OENV25 Envelope A2',
  '727826996100030': 'DA27OENV25 Envelope A2',
  '727826986600030': 'DA27OENV25 Envelope A2',
  '727826986700030': 'DA27OENV25 Envelope A2',
  '727826986800030': 'DA27OENV25 Envelope A2',
  '727826986900030': 'DA27OENV25 Envelope A2',
  '727826989400030': 'DA27OENV25 Envelope A2',
  '727826989500030': 'DA27OENV25 Envelope A2',
  '727826989600030': 'DA27OENV25 Envelope A2',
  '727826989700030': 'DA27OENV25 Envelope A2',
  '727826991800030': 'DA27OENV25 Envelope A2',
  '727826991900030': 'DA27OENV25 Envelope A2',
  '727826992000030': 'DA27OENV25 Envelope A2',
  '727826992100030': 'DA27OENV25 Envelope A2',


  // // DA770ENV25 Envelope A2
  // '727826433900030': 'DA77OENV25 Envelope A7',
  // '727826434000030': 'DA77OENV25 Envelope A7',
  // '727826434200030': 'DA77OENV25 Envelope A7',
  // '727826434300030': 'DA77OENV25 Envelope A7',
  // '727826434500030': 'DA77OENV25 Envelope A7',
  // '727826434600030': 'DA77OENV25 Envelope A7',
  // '727826434800030': 'DA77OENV25 Envelope A7',
  // '727826434900030': 'DA77OENV25 Envelope A7',
  // '727826436300030': 'DA77OENV25 Envelope A7',
  // '727826436400030': 'DA77OENV25 Envelope A7',
  // '727826436600030': 'DA77OENV25 Envelope A7',
  // '727826436700030': 'DA77OENV25 Envelope A7',
  // '727826446500030': 'DA77OENV25 Envelope A7',
  // '727826446600030': 'DA77OENV25 Envelope A7',
  // '727826446800030': 'DA77OENV25 Envelope A7',
  // '727826446900030': 'DA77OENV25 Envelope A7',
  // '727826447100030': 'DA77OENV25 Envelope A7',
  // '727826447200030': 'DA77OENV25 Envelope A7',
  // '727826447500030': 'DA77OENV25 Envelope A7',
  // '727826448900030': 'DA77OENV25 Envelope A7',
  // '727826449000030': 'DA77OENV25 Envelope A7',
  // '727826449200030': 'DA77OENV25 Envelope A7',
  // '727826449300030': 'DA77OENV25 Envelope A7',
  // // 2019 Card Line extensions
  // '727826987400030': 'DA77OENV25 Envelope A7',
  // '727826987500030': 'DA77OENV25 Envelope A7',
  // '727826987600030': 'DA77OENV25 Envelope A7',
  // '727826987700030': 'DA77OENV25 Envelope A7',
  // '727826988200030': 'DA77OENV25 Envelope A7',
  // '727826988300030': 'DA77OENV25 Envelope A7',
  // '727826988400030': 'DA77OENV25 Envelope A7',
  // '727826988500030': 'DA77OENV25 Envelope A7',
  // '727826989800030': 'DA77OENV25 Envelope A7',
  // '727826989900030': 'DA77OENV25 Envelope A7',
  // '727826990000030': 'DA77OENV25 Envelope A7',
  // '727826990100030': 'DA77OENV25 Envelope A7',
  // '727826990600030': 'DA77OENV25 Envelope A7',
  // '727826990700030': 'DA77OENV25 Envelope A7',
  // '727826990800030': 'DA77OENV25 Envelope A7',
  // '727826990900030': 'DA77OENV25 Envelope A7',
  // '727826994600030': 'DA77OENV25 Envelope A7',
  // '727826994700030': 'DA77OENV25 Envelope A7',
  // '727826994800030': 'DA77OENV25 Envelope A7',
  // '727826994900030': 'DA77OENV25 Envelope A7',
  // '727826995400030': 'DA77OENV25 Envelope A7',
  // '727826995500030': 'DA77OENV25 Envelope A7',
  // '727826995600030': 'DA77OENV25 Envelope A7',
  // '727826995700030': 'DA77OENV25 Envelope A7',
  // '727826987000030': 'DA77OENV25 Envelope A7',
  // '727826987100030': 'DA77OENV25 Envelope A7',
  // '727826987200030': 'DA77OENV25 Envelope A7',
  // '727826987300030': 'DA77OENV25 Envelope A7',
  // '727826989000030': 'DA77OENV25 Envelope A7',
  // '727826989100030': 'DA77OENV25 Envelope A7',
  // '727826989200030': 'DA77OENV25 Envelope A7',
  // '727826989300030': 'DA77OENV25 Envelope A7',
  // '727826991400030': 'DA77OENV25 Envelope A7',
  // '727826991500030': 'DA77OENV25 Envelope A7',
  // '727826991600030': 'DA77OENV25 Envelope A7',
  // '727826991700030': 'DA77OENV25 Envelope A7',
  
  // D1330012 Envelope A7
  '727826433900030': 'D1330012 Envelope A7',
  '727826434000030': 'D1330012 Envelope A7',
  '727826434200030': 'D1330012 Envelope A7',
  '727826434300030': 'D1330012 Envelope A7',
  '727826434500030': 'D1330012 Envelope A7',
  '727826434600030': 'D1330012 Envelope A7',
  '727826434800030': 'D1330012 Envelope A7',
  '727826434900030': 'D1330012 Envelope A7',
  '727826436300030': 'D1330012 Envelope A7',
  '727826436400030': 'D1330012 Envelope A7',
  '727826436600030': 'D1330012 Envelope A7',
  '727826436700030': 'D1330012 Envelope A7',
  '727826446500030': 'D1330012 Envelope A7',
  '727826446600030': 'D1330012 Envelope A7',
  '727826446800030': 'D1330012 Envelope A7',
  '727826446900030': 'D1330012 Envelope A7',
  '727826447100030': 'D1330012 Envelope A7',
  '727826447200030': 'D1330012 Envelope A7',
  '727826447500030': 'D1330012 Envelope A7',
  '727826448900030': 'D1330012 Envelope A7',
  '727826449000030': 'D1330012 Envelope A7',
  '727826449200030': 'D1330012 Envelope A7',
  '727826449300030': 'D1330012 Envelope A7',
  // 2019 Card Line extensions
  '727826987400030': 'D1330012 Envelope A7',
  '727826987500030': 'D1330012 Envelope A7',
  '727826987600030': 'D1330012 Envelope A7',
  '727826987700030': 'D1330012 Envelope A7',
  '727826988200030': 'D1330012 Envelope A7',
  '727826988300030': 'D1330012 Envelope A7',
  '727826988400030': 'D1330012 Envelope A7',
  '727826988500030': 'D1330012 Envelope A7',
  '727826989800030': 'D1330012 Envelope A7',
  '727826989900030': 'D1330012 Envelope A7',
  '727826990000030': 'D1330012 Envelope A7',
  '727826990100030': 'D1330012 Envelope A7',
  '727826990600030': 'D1330012 Envelope A7',
  '727826990700030': 'D1330012 Envelope A7',
  '727826990800030': 'D1330012 Envelope A7',
  '727826990900030': 'D1330012 Envelope A7',
  '727826994600030': 'D1330012 Envelope A7',
  '727826994700030': 'D1330012 Envelope A7',
  '727826994800030': 'D1330012 Envelope A7',
  '727826994900030': 'D1330012 Envelope A7',
  '727826995400030': 'D1330012 Envelope A7',
  '727826995500030': 'D1330012 Envelope A7',
  '727826995600030': 'D1330012 Envelope A7',
  '727826995700030': 'D1330012 Envelope A7',
  '727826987000030': 'D1330012 Envelope A7',
  '727826987100030': 'D1330012 Envelope A7',
  '727826987200030': 'D1330012 Envelope A7',
  '727826987300030': 'D1330012 Envelope A7',
  '727826989000030': 'D1330012 Envelope A7',
  '727826989100030': 'D1330012 Envelope A7',
  '727826989200030': 'D1330012 Envelope A7',
  '727826989300030': 'D1330012 Envelope A7',
  '727826991400030': 'D1330012 Envelope A7',
  '727826991500030': 'D1330012 Envelope A7',
  '727826991600030': 'D1330012 Envelope A7',
  '727826991700030': 'D1330012 Envelope A7',


  //Tags
  // '727826481700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826481800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826481900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826482900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826480900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826480700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826486200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826486100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826481000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826480800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826486000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826485900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826486400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826486300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826483600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // // 2019 Card Line extensions
  // '727826983400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826983500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826983600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826983700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826983800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826983900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826984900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826985900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
  // '727826986500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)'

  '727826481700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826481800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826481900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826482900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826480900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826480700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826486200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826486100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826481000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826480800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826486000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826485900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826486400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826486300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826483600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  // 2019 Card Line extensions
  '727826983400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826983500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826983600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826983700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826983800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826983900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826984900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985600030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985700030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985800030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826985900030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986000030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986100030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986200030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986300030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986400030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)',
  '727826986500030': 'DX2820008 - totalQty Strings (totalQty_25 packs of 25)'
};


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/printer-statuses.ts